<template>
  <div class="stepperCont" :class="{ horizontal: !isVertical }">
    <v-stepper
      style="width: min-content; padding-bottom: 0px"
      v-model="model"
      vertical
      :class="{ horizontal: !isVertical }"
      class="elevation-0 transparent"
    >
      <template v-for="n in steps">
        <v-stepper-step
          color="active"
          :key="`${n}-step`"
          :complete="model > n || model === steps"
          :complete-icon="mdiCheckCircle"
          :step="n"
        ></v-stepper-step>
        <v-stepper-content
          :key="`${n}-step-content`"
          :step="n"
        ></v-stepper-content>
      </template>
    </v-stepper>
  </div>
</template>

<script>
import { mdiCheckCircle } from '@mdi/js';
export default {
  props: {
    model: Number,
    steps: Number,
    isVertical: Boolean,
  },
  data() {
    return {
      mdiCheckCircle: mdiCheckCircle,
    };
  },
};
</script>

<style></style>
